import { IconContext } from "react-icons";
import { IoSendSharp } from "react-icons/io5";
import { IoIosEye } from "react-icons/io";
import { FaCaretRight } from "react-icons/fa";
import { FaCaretLeft } from "react-icons/fa";
import {AiOutlineLogout} from '@react-icons/all-files/ai/AiOutlineLogout.esm'
import { FaMessage } from "react-icons/fa6";
import { FiMail, FiPlus } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import { FiSearch } from "react-icons/fi";
import { GiConfirmed } from "react-icons/gi";
import { MdOutlineCopyAll } from "react-icons/md";
import { LuRefreshCcw } from "react-icons/lu";

const Icon=(props)=>{
    return <IconContext.Provider value={{ color: "#a3a8ab", className: "global-class-name",...props }}>
    {
        props?.onClick 
        ? <div style={{cursor:"pointer"}} onClick={props?.onClick}>
        {props?.children}
      </div>
        :<div>
        {props?.children}
      </div>
    }
    
    
  </IconContext.Provider>
}


export const IconSendMessage=(props)=>{

    return <Icon {...props}>
        <IoSendSharp/>
    </Icon>
}

export const IconAdd=(props)=>{

  return <Icon {...props}>
      <FiPlus/>
  </Icon>
}

export const IconView=(props)=>{

  return <Icon {...props}>
      <IoIosEye/>
  </Icon>
}

export const IconVerify=(props)=>{

  return <Icon {...props}>
      <GiConfirmed/>
  </Icon>
}

export const IconCopy=(props)=>{

  return <Icon {...props}>
      <MdOutlineCopyAll/>
  </Icon>
}

export const IconDelete=(props)=>{

  return <Icon {...props}>
      <FiTrash2/>
  </Icon>
}

export const IconNextList=(props)=>{

  return <Icon {...props}>
      <FaCaretRight/>
  </Icon>
}

export const IconPrevList=(props)=>{

  return <Icon {...props}>
      <FaCaretLeft/>
  </Icon>
}

export const IconLogout=(props)=>{

  return <Icon color="#fff" {...props}>
      <AiOutlineLogout />
  </Icon>
}

export const IconMessage=(props)=>{

  return <Icon {...props}>
      <FaMessage />
  </Icon>
}

export const IconMail=(props)=>{

  return <Icon {...props}>
      <FiMail />
  </Icon>
}

export const IconSearch=(props)=>{

  return <Icon {...props}>
      <FiSearch />
  </Icon>
}

export const IconRefresh=(props)=>{

  return <Icon {...props}>
      <LuRefreshCcw />
  </Icon>
}